
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 .667C4.405.667.667 4.405.667 9c0 4.595 3.738 8.333 8.333 8.333 4.595 0 8.333-3.738 8.333-8.333C17.333 4.405 13.595.667 9 .667zm0 15A6.674 6.674 0 012.333 9 6.674 6.674 0 019 2.333 6.674 6.674 0 0115.666 9 6.674 6.674 0 019 15.667z","fill":"#7E8186"}}),_c('path',{attrs:{"xmlns":"http://www.w3.org/2000/svg","d":"M10.386 4.714H8.719v5h5V8.048h-3.333V4.714z","fill":"#7E8186"}})])
          )
        }
      }
    